import { User } from './../../../core/models/auth.models';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { APPT_TYPES, CONTRACT_TYPES, INDUSTRIES, STATES, TIME_ZONES } from '../../constants';
import { TIMEZONES } from 'src/app/views/timezones';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractsService } from 'src/app/services/contracts/contracts.service';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { getFirebaseBackend } from 'src/app/authUtils';
import Swal from 'sweetalert2';


@Component({
	selector: 'app-campaign-wizard',
	templateUrl: './campaign-wizard.component.html',
	styleUrls: ['./campaign-wizard.component.scss'],
})
export class CampaignWizardComponent implements OnInit {
	@Input() contract_data: any;
	@Input() campaignId?: number; // Optional for edit mode
	@Output() submitSuccess = new EventEmitter<any>();
	@Output() cancelled = new EventEmitter<void>();

	// Form variables
	stepOneForm!: FormGroup;
	stepTwoForm!: FormGroup;
	stepThreeForm!: FormGroup;
	stepFourForm!: FormGroup;

	step = 1;

	submitted = false;
	isSubmitting = false;
	clientUsers = [];

	// Dropdown data
	industries = INDUSTRIES;
	states = STATES;
	showContracts = false;
	userContracts = [];
	user = {
		IdUser: 0
	};
	loading = false;
	loadingContracts = false;

	prospectTypes = [
		{ value: 'B2B', label: 'Business-to-Business' },
		{ value: 'B2C', label: 'Business-to-Consumer' },
	];
	timezones = TIME_ZONES;
	appt_types = APPT_TYPES;
	campaign_types = CONTRACT_TYPES;

	modalTitles = ['Basic Info', 'Address', 'Details', 'Notes', 'Review'];

	constructor(private campaignSrv: CampaignService, private contractSrv: ContractsService, private formBuilder: FormBuilder, private userSrv: UserService, public activeModal: NgbActiveModal,) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
	}

	ngOnInit(): void {
		this.initForm();

		this.getUsersForCampaign();

		if(this.contract_data) {
			console.info('Contract data', this.contract_data);
			this.stepOneForm.patchValue({
				user_id: this.contract_data.user_id,
				alias: this.contract_data.alias,
				contract_id: this.contract_data.contract_id,
				industry: this.contract_data.industry,
				pricing_description: this.contract_data.pricing_description,
				pricing_value: this.contract_data.pricing_value,
			});

			this.stepOneForm.get('user_id')?.markAsTouched();
			this.stepOneForm.get('contract_id')?.markAsTouched();
			this.stepOneForm.get('industry')?.markAsTouched();


			this.getUserContracts(this.contract_data.user_id);
		}


		if (this.campaignId) {
			this.loadCampaignData();
		}
	}

	/**
	 * Initialize the campaign form with validations
	 */
	initForm(): void {
		// Create separate FormGroups for each step
		this.stepOneForm = this.formBuilder.group({
			name: ['', [Validators.required]],
			user_id: ['', [Validators.required]],
			alias: ['', [Validators.required]],
			contract_id : [''],
			timezone: ['', [Validators.required]],
			industry: [''],
			appt_types: ['', [Validators.required]],
			reserve: [''],
			source: ['', [Validators.required]],
			campaign_type: ['',],
			prospects_type: ['B2B', [Validators.required]],
			pricing_description: [''],
			pricing_value: [''],
		});
		this.stepOneForm.get('prospects_type')?.markAsTouched();

		this.stepTwoForm = this.formBuilder.group({
			address_1: ['', [Validators.required]],
			address_2: [''],
			city: ['', [Validators.required]],
			state: ['', [Validators.required]],
			zip: ['', [Validators.required]],
			website_url: [''],
			additional_calendar_url: [''],
		});

		this.stepThreeForm = this.formBuilder.group({
			script: [''],
			who_we_are: [''],
			what_we_do: [''],
			why_us: [''],
			email_template: [''],
		});

		this.stepFourForm = this.formBuilder.group({
			campaign_notes: [''],
			billing_notes: [''],
		});
	}

	campaign = {
		name: '',
		alias: '',
		timezone: '',
		industry: 0,
		appt_types: '',
		reserve: 0,
		source: '',
		campaign_type: 'D',
		prospects_type: 'B2B',
		address_1: '',
		address_2: '',
		city: '',
		state: '',
		zip: '',
		website_url: '',
		additional_calendar_url: '',
		who_we_are: '',
		what_we_do: '',
		why_us: '',
		script: '',
		questions: '',
		notes: '',
		email_template: '',
		attending: '',
		scheduling: '',
		campaign_notes: '',
		billing_notes: '',
		created_by: this.user.IdUser,
		pricing_description: '',
		pricing_value: 0
	};

	/**
	 * Load campaign data for edit mode
	 */
	loadCampaignData(): void {
		// Here you would call a service to fetch campaign data by ID
		// For now, let's just simulate it
		const dummyCampaign = {
			name: 'Example Campaign',
			alias: 'EC-2023',
			campaign_type: 'D',
			// Include other fields here
		};

		// Replace this with actual form patching when API is connected
	}

	next() {
		if (this.step === 1 && !this.stepOneForm.valid) {
			Object.keys(this.stepOneForm.controls).forEach((key) => {
				const control = this.stepOneForm.get(key);
				control?.markAsTouched();
			});
			return;
		}

		if (this.step === 2 && !this.stepTwoForm.valid) {
			Object.keys(this.stepTwoForm.controls).forEach((key) => {
				const control = this.stepTwoForm.get(key);
				control?.markAsTouched();
			});
			return;
		}

		if (this.step === 3 && !this.stepThreeForm.valid) {
			Object.keys(this.stepThreeForm.controls).forEach((key) => {
				const control = this.stepThreeForm.get(key);
				control?.markAsTouched();
			});
			return;
		}

		if (this.step === 4 && !this.stepFourForm.valid) {
			Object.keys(this.stepFourForm.controls).forEach((key) => {
				const control = this.stepFourForm.get(key);
				control?.markAsTouched();
			});
			return;
		}

		// Sync values with contract object based on current step
		if (this.step === 1) {
			const formValues = this.stepOneForm.value;
			Object.keys(formValues).forEach((key) => {
				this.campaign[key] = formValues[key];
			});
		} else if (this.step === 2) {
			const formValues = this.stepTwoForm.value;
			Object.keys(formValues).forEach((key) => {
				this.campaign[key] = formValues[key];
			});
		} else if (this.step === 3) {
			const formValues = this.stepThreeForm.value;
			Object.keys(formValues).forEach((key) => {
				this.campaign[key] = formValues[key];
			});
		} else if (this.step === 4) {
			const formValues = this.stepFourForm.value;
			Object.keys(formValues).forEach((key) => {
				this.campaign[key] = formValues[key];
			});
			this.createCampaign();
		}

		if (this.step < 4) {
			this.step++;
		}
	}

	prev() {
		if (this.step > 1) {
			this.step--;
		}
	}



	/**
	 * Cancel wizard
	 */
	cancel(): void {
		this.cancelled.emit();
	}

	getUsersForCampaign() {
		this.userSrv.getClientUserStatus(1).subscribe((res: any) => {
			this.clientUsers = res.body;
		});
	}

	// Track selected appointment types
	selectedApptTypes: number[] = [];

	updateSelectedApptTypes(typeId: number) {
		// Check if the appointment type is already selected
		const index = this.selectedApptTypes.indexOf(typeId);

		// Toggle selection: add if not present, remove if already selected
		if (index === -1) {
			this.selectedApptTypes.push(typeId);
		} else {
			this.selectedApptTypes.splice(index, 1);
		}

		// Create a comma-separated string of selected appointment types
		const commaSeparatedTypes = this.selectedApptTypes.join(',');

		// Update the form control value
		this.stepOneForm.patchValue({
			appt_types: commaSeparatedTypes,
		});

		// Mark as touched to trigger validation
		this.stepOneForm.get('appt_types')?.markAsTouched();
	}

	createCampaign(){

		// Validate all forms are valid before submitting
		if (!this.stepOneForm.valid || !this.stepTwoForm.valid ||
			!this.stepThreeForm.valid || !this.stepFourForm.valid) {
			console.error('Please fill all required fields in the forms.');
		  return;
		}

		this.loading = true;
		this.isSubmitting = true;
		this.campaignSrv.saveCampaignNew(this.campaign).subscribe(
			(response) => {
				this.loading = false;
				this.activeModal.close(response);
				Swal.fire('Success', 'Campaign created successfully!', 'success');
			  },
			  (error) => {
				console.error('Error creating campaign:', error);
			  }
		);

	}

	validateField(formGroup: FormGroup, fieldName: string): boolean {
		const field = formGroup.get(fieldName);
		return field ? field.valid && field.touched : false;
	}

	getUserContracts(user_id = null) {
		this.showContracts = true;
		this.loadingContracts = true;
		// If null means calling from the front
		if (!user_id) {
			user_id = this.stepOneForm.get('user_id')?.value;
			const matchedUser = this.clientUsers.find((user: any) => user.id == user_id);
			if (matchedUser) {
				this.stepOneForm.patchValue({ alias: matchedUser.alias });
			}
		}

		this.contractSrv.getUserContractsForCampaignWizard(user_id).subscribe((res: any) => {
			this.loadingContracts = false;
			this.userContracts = res.body;
		});
	}
}
